<div class="referral-container">
  <h3>کد و لینک ریفرال شما</h3>
  <p>
    با استفاده از این لینک شما میتوانید دوستان خود را دعوت به عضویت کنید و با
    تراکنش آنها امتیاز دریافت کنید
  </p>
  <mat-divider></mat-divider>
  <br />
  <div class="referral" fxLayout="column" fxLayoutAlign="center center">
    <h1 class="code">{{ referral.code }}</h1>
    <div class="link-holder" fxFlex="100">
      <mat-form-field style="width: 100%" class="holder" appearance="outline">
        <input type="text" [disabled]="true" dir="ltr" [value]="url" matInput />
      </mat-form-field>
      <button mat-button color="primary" (click)="copyToClipboard()">
        کپی لینک
      </button>
    </div>
  </div>
</div>
